import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ChipItem } from '../../custom-chip/custom-chip.component';

@Component({
  selector: 'app-hire-suggestions-list',
  standalone: true,
  imports: [CommonModule, TitleCasePipe],
  templateUrl: './hire-suggestions-list.component.html',
  styleUrl: './hire-suggestions-list.component.scss',
})
export class HireSuggestionsListComponent {
  /** List of suggestion items to show as clickable + text */
  @Input() suggestions: ChipItem[] = [];

  /** Controls only the "AI Suggestions" heading (icon + text) — the suggestion chips still show regardless. */
  @Input() showAiLabel: boolean = false;

  /** Emits the item when clicked — parent adds it as a chip */
  @Output() suggestionAdded = new EventEmitter<ChipItem>();

  onAdd(chip: ChipItem): void {
    this.suggestionAdded.emit(chip);
  }

  ngOnInit(): void {
    // console.log('HireSuggestionsListComponent initialized with suggestions:', this.suggestions);
  }
}
